<script lang="ts">
  import { onMount } from "svelte";

  export let barTop: string = "0px";
  export let barHeight: string = "30px;";
  export let background: string = "#dbdbdb";
  export let transition: string = "1s";

  let loadingElem: HTMLElement, loadingIconElem: HTMLElement;
  let barElem: HTMLElement;
  const load = () => {
    if (!loadingElem) {
      return;
    }
    loadingElem.style.transition = transition;
    loadingIconElem.style.transition = transition;
    loadingElem.style.background = background;
  };

  onMount(() => {
    load();
    barElem.style.setProperty("height", barHeight);
    barElem.style.setProperty("top", barTop);
  });
</script>

<div class="container" bind:this={loadingElem}>
  <div class="loadingIconElem-wrapper">
    <img
      src="/imgs/loading.svg/"
      alt="Loading"
      class="loadingIconElem rotate"
      bind:this={loadingIconElem}
    />
    <div class="css-keeper fadeout" />
  </div>
  <div class="progress-bar" bind:this={barElem}>
    <div class="cover color-1 move right" />
    <div class="cover transp move left" />
  </div>
</div>

<style>
  .progress-bar {
    position: absolute;
    right: 0;
    width: 100%;
  }
  .cover {
    position: absolute;
    left: 0;
    width: 200%;
    height: 100%;
  }
  .color-1 {
    background: linear-gradient(90deg, #b4d9dd 25%, #eec768 60%, #dc8279);
    background-size: 50% 100%;
  }
  .transp {
    background: linear-gradient(270deg, #333, #777);
    mix-blend-mode: screen;
    opacity: 0.8;
    background-size: 50% 100%;
  }
  .move.right {
    animation: 1.5s scroll-right infinite ease-in-out;
    /* animation-direction: alternate; */
    /* animation-delay: 0.2s; */
  }

  .move.left {
    animation: 1.5s scroll-left infinite ease-in-out;
    /* animation-direction: alternate; */
    /* animation-delay: 0.5; */
  }
  .container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 1;
    mix-blend-mode: hard-light;
    overflow: hidden;
  }
  .loadingIconElem {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 10rem;
    height: 10rem;
    opacity: 1;
  }
  .fadeout {
    opacity: 0;
  }
  .rotate {
    animation: 2s rotate infinite linear;
  }
  @keyframes rotate {
    from {
      transform: translate(-50%, -50%) rotate(0deg);
    }
    to {
      transform: translate(-50%, -50%) rotate(360deg);
    }
  }
  @keyframes scroll-right {
    from {
      background-position: left;
    }
    10% {
      background-position: left;
    }
    to {
      /* background-position: 600px; */
      background-position: right;
    }
  }
  @keyframes scroll-left {
    from {
      background-position: left;
    }
    to {
      /* background-position: 600px; */
      background-position: right;
    }
  }
  .css-keeper {
    display: none;
  }
</style>
